import { render, staticRenderFns } from "./ChatHistory.vue?vue&type=template&id=376844f6&scoped=true"
import script from "./ChatHistory.vue?vue&type=script&lang=ts"
export * from "./ChatHistory.vue?vue&type=script&lang=ts"
import style0 from "./ChatHistory.vue?vue&type=style&index=0&id=376844f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "376844f6",
  null
  
)

export default component.exports